// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"659":"7661fac7","753":"2853cbb5"}[chunkId] + ".css";
};